"use client";

import { useState } from "react";
import { SectionHeader } from "./SectionHeader";
import { Icons } from "./Icons";
import { cn } from "@/lib/utils";
import { usePathname } from "next/navigation";
import { getLocaleFromPathname } from "@/lib/i18n";
import { getSiteContent } from "@/lib/site-content";

export function WorkingProcess() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  const pathname = usePathname() || "/";
  const locale = getLocaleFromPathname(pathname);
  const content = getSiteContent(locale).landing;

  const toggle = (index: number) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  return (
    <section id="how-it-works" className="container mx-auto px-4 md:px-6 py-12">
      <SectionHeader 
        title={content.processTitle} 
        description={content.processDescription}
      />
      
      <div className="space-y-6">
        {content.processSteps.map((process, index) => {
          const isOpen = openIndex === index;
          return (
            <div 
              key={index} 
              className={cn(
                "rounded-[45px] border border-positivus-dark p-8 md:p-12 transition-all duration-300",
                isOpen ? "bg-positivus-green" : "bg-positivus-grey"
              )}
            >
              <div 
                className="flex items-center justify-between cursor-pointer"
                onClick={() => toggle(index)}
              >
                <div className="flex items-center gap-6">
                  <span className="text-4xl md:text-6xl font-medium">{process.number}</span>
                  <h3 className="text-xl md:text-3xl font-medium">{process.title}</h3>
                </div>
                <div className="flex-shrink-0 w-12 h-12 rounded-full border border-positivus-dark flex items-center justify-center bg-white">
                  {isOpen ? <Icons.minus /> : <Icons.plus />}
                </div>
              </div>
              
              {isOpen && (
                <div className="mt-8 border-t border-black/20 pt-8">
                  <p className="text-lg md:text-xl">
                    {process.description}
                  </p>
                </div>
              )}
            </div>
          );
        })}
      </div>
    </section>
  );
}
